const verge = require('verge');

global.inWidth = function (maxwidth = 1920, minWidth = 319) {
	let currentWidth = verge.viewportW();
	if (maxwidth >= currentWidth && minWidth < currentWidth) {
		return true;
	} else {
		return false;
	}
};